// import { roundPrice } from 'utils/orders.ts';

import { CalculateOrderPricesArgs, OrderPricesResult } from 'pages/Order/Order.types';
import { roundPrice } from 'utils/orders';

export function calculateOrderPrices(args: CalculateOrderPricesArgs): OrderPricesResult {
    const { products, priceDelivery } = args;

    const allOrderedProductsPrice = products.reduce((acc, product) => {
        const unitPrice = product.unitPrice ?? 0;
        const quantity = product.quantity ?? 0;
        acc += roundPrice(unitPrice * quantity);
        return acc;
    }, 0);

    const allProductsPrice = products.reduce((acc, product) => {
        const unitPrice = product.unitPrice ?? 0;
        const quantity = product.quantity ?? 0;
        const quantityPicked = product.quantityPicked ?? quantity;
        acc += roundPrice(unitPrice * quantityPicked);
        return acc;
    }, 0);

    const allProductPriceWithDelivery = allProductsPrice + priceDelivery;

    return { allOrderedProductsPrice, allProductsPrice, allProductPriceWithDelivery };
}
